import {useIsDesktop} from '@eCommerce/frontend-legacy-shared-library-native';
import {VStack} from 'native-base';
import React, {useState} from 'react';

import OcrmReward from 'containers/OfferDetails/OcrmReward/OcrmReward';
import {OCRMReward, RewardState} from 'models/Offer';

interface OcrmRewardListProps {
  rewards: OCRMReward[];
  selectedReward: OCRMReward | undefined;
  onSelected: (reward: OCRMReward | undefined) => void;
  isDownloadVisible?: boolean;
  setIsDownloadVisible?: (isVisible: boolean) => void;
  onDownloadPress?: () => void;
}

const OcrmRewardList = (props: OcrmRewardListProps) => {
  const {
    onSelected,
    isDownloadVisible,
    setIsDownloadVisible,
    onDownloadPress,
    selectedReward,
  } = props;
  const isDesktop = useIsDesktop();
  const hasAccepted = props.rewards.find(r => r.state === RewardState.SUCCESS);
  const rewards = hasAccepted ? [hasAccepted] : props.rewards;
  const selected = hasAccepted ? hasAccepted.id : selectedReward?.id;

  return (
    <VStack zIndex={-1} space={isDesktop ? 8 : 4}>
      {rewards.map((r, i) => (
        <OcrmReward
          key={`ocrm-reward-${i}-${r.id}`}
          reward={r}
          onSelected={() => onSelected(r)}
          selected={r.id === selected}
          isDownloadVisible={isDownloadVisible}
          setIsDownloadVisible={setIsDownloadVisible}
          onDownloadPress={onDownloadPress}
        />
      ))}
    </VStack>
  );
};

export default OcrmRewardList;
